<nav class="navbar navbar-expand-lg">
    <div class="container-fluid justify_end_header">
        <!-- Toggle Button for Small Screens -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ng-container *ngIf="menuList?.length">
                <ul class="navbar-nav">
                    <ng-container *ngFor="let menu of visibleMenus; index as menuIndex">
                        <li class="nav-item list_itm"
                            [ngClass]="{'active-menu': menu.activate, 'active-state': menu.activate && position === 1}"
                            *ngxPermissionsOnly="menu?.permission">
                            <ng-container
                                *ngTemplateOutlet="submenus; context: { $implicit:menu, index:menuIndex, position:1 }">
                            </ng-container>
                        </li>
                    </ng-container>

                    <li *ngIf="moreMenus.length" class="nav-item dropdown list_itm more_menu ms-2">
                        <a class="nav-link dropdown-toggle" href="#" id="moreMenuDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false" onkeydown="">
                            <img src="../../../assets/images/common/icons/hamburger_portal.svg" alt="">
                        </a>
                        <ul class="dropdown-menu more_dropdown" aria-labelledby="moreMenuDropdown">
                            <ng-container *ngFor="let menu of moreMenus; index as moreIndex">
                                <li class="dropdown-item p-0 position-relative"
                                    [ngClass]="{'active-menu': menu.activate, 'active-state': menu.activate && position === 1}"
                                    *ngxPermissionsOnly="menu?.permission">
                                    <ng-container
                                        *ngTemplateOutlet="submenus; context: { $implicit:menu, index:moreIndex, position:1 }">
                                    </ng-container>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ul>

            </ng-container>
        </div>
    </div>

    <!-- Submenu Template -->
    <ng-template #submenus let-menu let-idx="index" let-position="position">
        <ng-container>
            <div class="cursor-pointer text-capitalize pos-menu">
                <div class="inner-menu-box" (click)="redirect(menu)" (keydown)="redirect(menu)">

                    <ng-container *ngIf="menu?.icon">
                        <div class="px-1 d-flex align-items-center left-icon">
                            <img class="menus_image" [src]="'../../../assets/images/common/icons/'+ menu?.icon +'.svg'"
                                [alt]="menu?.icon">
                        </div>
                    </ng-container>

                    <div class="menu-name">
                        <a href="javascript:void(0);" [routerLink]="menu?.router"
                            class="text-decoration-none">{{menu.name}}
                        </a>
                        <span class="dropdown-icons" *ngIf="menu?.mainMenu && menu?.children?.length">
                            <img src="../../../assets/images/common/icons/dropdown_arow_down.svg" alt="Dropdown icon"
                                class="icon dropdown-icon cursor-pointer" [class.rotate]="isPopupVisible" />
                        </span>
                    </div>
                </div>
            </div>

            <!-- Submenus (Dropdowns) -->
            <ng-container>
                <span class="subdropdown-icons" *ngIf="menu?.subMenu && position > 1">
                    <img src="../../../assets/images/common/icons/right_dropdown_icon.svg" alt="Dropdown icon"
                        class="icon cursor-pointer" [class.rotate]="isPopupVisible" />
                </span>
                <ul class="dropdown-menu dropdown_ul">
                    <ng-container *ngFor="let submenu of menu?.children; index as subParentIndex">
                        <li [ngClass]="getSubmenuClass(submenu.activate, position)" class="dropdown-item sub_menu_li"
                            href="#" *ngxPermissionsOnly="submenu?.permission">
                            <ng-container
                                *ngTemplateOutlet="submenus; context: { $implicit:submenu, index:subParentIndex, position:(position + 1) }">
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>
            </ng-container>
        </ng-container>
    </ng-template>
</nav>